export const ORDER_SUCCESS = 'icon1';
// 优先唱统计：https://m2miovoqda.feishu.cn/wiki/wikcnFJWBUNfOXUcOlj39F0EOOb#CDWVdP
export const YOUXIANCHANG = {
  '_wcctj_home': {
    name: '无常唱推荐歌曲',
    payenter: 'ordertoast_sycc',
    payenter1: 'ordertoast_sycc_1',
  },
  '_ccgq_home': {
    name: '有常唱歌曲',
    payenter: 'ordertoast_sycc',
    payenter1: 'ordertoast_sycc_1',
  },
  '_ycctj_home': {
    name: '有常唱推荐歌曲',
    payenter: 'ordertoast_sycc',
    payenter1: 'ordertoast_sycc_1',
  },
  '_home': {
    name: '首页推荐歌单',
    payenter: 'ordertoast_sy',
    payenter1: 'ordertoast_sy_1',
  },
  '_searchresult': {
    name: '搜索结果页',
    payenter: 'ordertoast_ssjg',
  },
  '_search_hot': {
    name: '搜索初始页-热搜榜',
    payenter: 'search_hot',
  },
  '_search_hsong': {
    name: '搜索初始页-热唱榜',
    payenter: '_search_hsong',
  },
  'search_cnxh': {
    name: '搜索初始页-猜你喜欢',
    payenter: 'search_cnxh',
  },
  default: {
    name: '搜索初始页及其他',
    payenter: 'ordertoast_ss',
    payenter1: 'ordertoast_ss_1',
  },
}
export const GOLD_PRICE = {
  vip: 990,
  notVip: 1990,
}
export const SHIHUI_LINK = 'https://tq.jfshou.cn/seller/classify?agentId=558&inviteBuyerId=12778635&shareBuyerId=0&wxCode=365TQ'
export const miniRoutes = {
  '/thunder/home': '/pages/index/index',
  '/thunder/interact': '/pages/interact/index',
  '/thunder/bar': '/pages/interact/index',
  '/thunder/classify_singer': '/pages/song_list/singer_list',
  '/thunder/search': '/pages/song_list/search',
  '/thunder/ordered': '/pages/song_list/ordered',
  '/thunder/choiceTop': '/pages/song_list/choiceTop',
  '/thunder/openvip': '/pages/vip/openvip',
  '/thunder/banzou_vip': '/pages/song_list/banzou_vip',
}
// 开屏弹窗：减5元红包：https://m2miovoqda.feishu.cn/wiki/wikcnJRn2I88HmxyrkPqBwbOQTf
export const FirstHomeToastDiscount = {
  selectIndex: 1,
  isDiscount: true,
  isMonthDiscount: true,
  discountIndex: 1,
  discountDayFee: '0.02',
  memberIdArr: [78, 52, 50],
  price: [990, 1490, 2190],
  packagesContent: {
    month: ['24小时', '1个月', '3个月'],
    current: ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥9.9', '¥14.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['', '老客减5元', ''],
  },
  giveFriendPackages: [{
    'pkg_id': 77,
    'current_fee': 1980,
    'desc': '1日体验+赠送好友',
    'days': 1,
  },
  {
    'pkg_id': 51,
    'desc': '29.8元/1个月',
    'origin_fee': 3980,
    'current_fee': 2980,
    'days': 30,
  },
  {
    'pkg_id': 49,
    'current_fee': 4380, // 3980
    'desc': '3个月+赠送好友',
    'days': 365,
  }],
}
export const MonthFirstSkuToast = {
  selectIndex: 0,
  isSpecialPackages: 1,
  isDiscount: true,
  isMonthDiscount: true,
  discountIndex: 0,
  discountDayFee: '0.02',
  memberIdArr: [52, 78, 50],
  price: [1490, 990, 2190],
  packagesContent: {
    month: ['1个月', '24小时', '3个月'],
    current: ['¥<span>0.02</span>/小时', '¥<span>0.41</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥14.9<i>¥19.9</i>', '¥9.9', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['限时减5元', '', ''],
  },
  originPkgs: [
    {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.90',
      'day_fee': 0.41
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 51,
      'desc': '29.8元/1个月',
      'origin_fee': 3980,
      'current_fee': 2980,
      'days': 30,
    },
    {
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1日体验+赠送好友',
      'days': 1,
    },
    {
      'pkg_id': 49,
      'current_fee': 4380, // 3980
      'desc': '3个月+赠送好友',
      'days': 365,
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 75,
        'current_fee': 3980, // 3380
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
      },
    ],
}
export const newVipLastSkuDiscount = {
  memberIdArr: [78, 52, 50],
  price: [990, 1490, 2190],
  packagesContent: {
    month: ['24小时', '1个月', '3个月'],
    current: ['¥<span>0.41</span>/小时', '¥<span>0.03</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥9.9', '¥14.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['', '老客减5元', ''],
  },
  originPkgs: [
    {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.9',
      'day_fee': 0.41
    }, {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1天+赠送好友',
      'days': 1,
    }, {
      'pkg_id': 51,
        'desc': '29.8元/1个月',
        'origin_fee': 3980,
        'current_fee': 2980,
        'days': 30,
    }, {
      'pkg_id': 49,
      'current_fee': 4380,
      'desc': '3个月+赠送好友',
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 75,
        'current_fee': 3980, // 3399
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 37,
        'current_fee': 15980,
        'desc': '3个月+赠送好友',
      },
  ],
}
export const newRole4MonthSkuDiscount7 = {
  memberIdArr: [78, 70, 50],
  price: [990, 1690, 2190],
  packagesContent: {
    month: ['24小时', '1个月', '3个月'],
    current: ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥9.9', '¥16.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['', '续费立省', ''],
  },
  originPkgs: [
    {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.9',
      'day_fee': 0.41
    }, {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1天+赠送好友',
      'days': 1,
    }, {
      'pkg_id': 34,
        'desc': '31.8元/1个月',
        'origin_fee': 3980,
        'current_fee': 3380,
        'days': 30,
    }, {
      'pkg_id': 49,
      'current_fee': 4380,
      'desc': '3个月+赠送好友',
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 75,
        'current_fee': 3980, // 3399
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
      }
  ],
}
export const newRole4MonthFirstSkuToast7 = {
  selectIndex: 0,
  isSpecialPackages: 1,
  isDiscount: true,
  isMonthDiscount: true,
  discountIndex: 0,
  discountDayFee: '0.02',
  memberIdArr: [70, 78, 50],
  price: [1690, 990, 2190],
  packagesContent: {
    month: ['1个月', '24小时', '3个月'],
    current: ['¥<span>0.02</span>/小时', '¥<span>0.41</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥16.9<i>¥19.9</i>', '¥9.9', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['续费立省', '', ''],
  },
  originPkgs: [
    {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.9',
      'day_fee': 0.41
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 34,
      'desc': '33.8元/1个月',
      'origin_fee': 3980,
      'current_fee': 3380,
      'days': 30,
    },
    {
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1日体验+赠送好友',
      'days': 1,
    },
    {
      'pkg_id': 49,
      'current_fee': 4380, // 3999
      'desc': '3个月+赠送好友',
      'days': 365,
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 75,
        'current_fee': 3980, // 3399
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
      },
    ],
}
export const newRole4MonthSkuDiscount90 = {
  memberIdArr: [78, 31, 50],
  price: [990, 1390, 2190],
  packagesContent: {
    month: ['24小时', '1个月', '3个月'],
    current: ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥9.9', '¥13.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['', '立减6元', ''],
  },
  originPkgs: [
    {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.9',
      'day_fee': 0.41
    }, {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1天+赠送好友',
      'days': 1,
    }, {
      'pkg_id': 33,
        'desc': '31.8元/1个月',
        'origin_fee': 3980,
        'current_fee': 2780,
        'days': 30,
    }, {
      'pkg_id': 49,
      'current_fee': 4380,
      'desc': '3个月+赠送好友',
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 75,
        'current_fee': 3980, // 3399
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
      }
  ],
}
export const newRole4MonthFirstSkuToast90 = {
  selectIndex: 0,
  isSpecialPackages: 1,
  isDiscount: true,
  isMonthDiscount: true,
  discountIndex: 0,
  discountDayFee: '0.02',
  memberIdArr: [31, 78, 50],
  price: [1390, 990, 2190],
  packagesContent: {
    month: ['1个月', '24小时', '3个月'],
    current: ['¥<span>0.02</span>/小时', '¥<span>0.41</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥13.9<i>¥19.9</i>', '¥9.9', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['立减6元', '', ''],
  },
  originPkgs: [
    {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.9',
      'day_fee': 0.41
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 33,
      'desc': '27.8元/1个月',
      'origin_fee': 3980,
      'current_fee': 2780,
      'days': 30,
    },
    {
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1日体验+赠送好友',
      'days': 1,
    },
    {
      'pkg_id': 49,
      'current_fee': 4380, // 3999
      'desc': '3个月+赠送好友',
      'days': 365,
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 75,
        'current_fee': 3980, // 3399
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
      },
    ],
}
export const ORDER_ICON = {
  vip: 'https://qncweb-back1.ktvsky.com/20230228/other/6b761eca47cf3e85c5f290ec16f20bf4.png',
  normal: 'https://qncweb-back1.ktvsky.com/20230228/other/7d6c91bd8b37988e380197e5bceaf224.png',
}
export const FOOTRT_ICON_THEME = {
  default: {
    icon: [
      'https://qncweb-back1.ktvsky.com/20230816/other/50046241571e2302b33ba103539a375d.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/bff0c7971313db1dbfdc8056ed93f88d.png',
      'https://qncweb-back1.ktvsky.com/20240117/vadd/d45152ab1ac9343cd406a5c2523faaf6.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/6808be59ac4f397d3cd9d2ac32571e1b.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/54a9fb7dd86052a672e28d9cacc3c76d.png',
    ],
    activeIcon: [
      'https://qncweb-back1.ktvsky.com/20230816/other/ab2efc87ffcc004094660459ba6ef9a0.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/dcaf332583061ac8bcc04d87c0b9743c.png',
      'https://qncweb-back1.ktvsky.com/20240117/vadd/31b9ed7ddbe5f8d77c599ba8f496771c.png',
      'https://qncweb-back1.ktvsky.com/20240117/vadd/7fee6ac694fbf6b9bfe39b9739c94160.png',
      'https://qncweb-back1.ktvsky.com/20240117/vadd/b7f203af978eb77258d106721a5686e1.png',
    ]
  },
  light: {
    icon: [
      'https://qncweb-back1.ktvsky.com/20230816/other/50046241571e2302b33ba103539a375d.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/bff0c7971313db1dbfdc8056ed93f88d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/1947242f39b459f1708d489e70bf5962.png',
      'https://qncweb.ktvsky.com/20250627/vadd/195e9fd757cf3c22b9e19cfa89b3173d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/54a9fb7dd86052a672e28d9cacc3c76d.png',
    ],
    activeIcon: [
      'https://qncweb-back1.ktvsky.com/20231229/vadd/3f34153f0a5d6491e0646e4792602160.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/0bab065702c13fd7ab51c654cdba8f0d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/3968782ff879b36adde843e7f266c444.png',
      'https://qncweb.ktvsky.com/20250627/vadd/79ad6dac0b1d97a81e41ab6f9be1dea4.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/a89519c8ec416c60a0c3d1050e7875bb.png',
    ]
  },
  dark: {
    icon: [
      'https://qncweb-back1.ktvsky.com/20230816/other/50046241571e2302b33ba103539a375d.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/bff0c7971313db1dbfdc8056ed93f88d.png',
      'https://qncweb.ktvsky.com/20251202/vadd/c89e3ec1900c1b97c10634af264c9ea6.png',
      'https://qncweb.ktvsky.com/20250627/vadd/195e9fd757cf3c22b9e19cfa89b3173d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/54a9fb7dd86052a672e28d9cacc3c76d.png',
    ],
    activeIcon: [
      'https://qncweb.ktvsky.com/20251202/vadd/7e0054b663abf946771565065ac60b25.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/0bab065702c13fd7ab51c654cdba8f0d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/3968782ff879b36adde843e7f266c444.png',
      'https://qncweb.ktvsky.com/20250627/vadd/79ad6dac0b1d97a81e41ab6f9be1dea4.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/a89519c8ec416c60a0c3d1050e7875bb.png',
    ]
  },
  blue: {
    icon: [
      'https://qncweb-back1.ktvsky.com/20230816/other/50046241571e2302b33ba103539a375d.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/bff0c7971313db1dbfdc8056ed93f88d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/1947242f39b459f1708d489e70bf5962.png',
      'https://qncweb.ktvsky.com/20250627/vadd/195e9fd757cf3c22b9e19cfa89b3173d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/54a9fb7dd86052a672e28d9cacc3c76d.png',
    ],
    activeIcon: [
      'https://qncweb-back1.ktvsky.com/20231229/vadd/3f34153f0a5d6491e0646e4792602160.png',
      'https://qncweb-back1.ktvsky.com/20240403/other/0bab065702c13fd7ab51c654cdba8f0d.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/3968782ff879b36adde843e7f266c444.png',
      'https://qncweb.ktvsky.com/20250627/vadd/79ad6dac0b1d97a81e41ab6f9be1dea4.png',
      'https://qncweb-back1.ktvsky.com/20231229/vadd/a89519c8ec416c60a0c3d1050e7875bb.png',
    ]
  },
}
export const ORDER_ICON_THEME = {
  default: {
    vip: 'https://qncweb-back1.ktvsky.com/20230228/other/6b761eca47cf3e85c5f290ec16f20bf4.png',
    normal: 'https://qncweb-back1.ktvsky.com/20230228/other/7d6c91bd8b37988e380197e5bceaf224.png',
    playing: 'https://qncweb-back1.ktvsky.com/20221014/other/d07f867eac746772bf331b2d2c07d7cf.png',
    vipTitle: 'https://qncweb-back1.ktvsky.com/20221014/other/1ede9041e80fb05136b9e69117f8b044.png',
    top: 'https://qncweb-back1.ktvsky.com/20230116/vadd/8f4e7e41537b04ad96cef23cf5b0d077.png',
    delete: 'https://qncweb-back1.ktvsky.com/20230116/vadd/7234ec63efbdf628f036d1190bd650d2.png',
    recentSong: 'https://qncweb-back1.ktvsky.com/20231201/vadd/3bf547f5a72e1909493e0b16adf989ff.png',
    vipFirst: 'https://qncweb-back1.ktvsky.com/20240126/vadd/28bd2b26420b332630765e37f8979365.png',
    recommendVip: 'https://qncweb.ktvsky.com/20250611/vadd/f30be27b937e5f9b562b7d63e0d924ba.png',
    recommendNormal: 'https://qncweb.ktvsky.com/20250611/vadd/3691b49e66c19c411e7506b4516d9228.png',
  },
  light: {
    vip: 'https://qncweb-back1.ktvsky.com/20231213/other/b169c62f20b31a066f4cad1b522296d1.png',
    normal: 'https://qncweb-back1.ktvsky.com/20231213/other/f4dbbb5eb0d63b4b5d5cd87ad8c2a225.png',
    playing: 'https://qncweb-back1.ktvsky.com/20231229/vadd/4d7725826b9d5d9fb310328491232462.png',
    vipTitle: 'https://qncweb-back1.ktvsky.com/20231229/vadd/2e59772e1695c0c987ab66507574612e.png',
    top: 'https://qncweb-back1.ktvsky.com/20231228/vadd/c77c9f60842f004130a0c51ee5ab1ea9.png',
    delete: 'https://qncweb-back1.ktvsky.com/20231228/vadd/081a54e9ebe7257bdd7111cc442ab5a1.png',
    recentSong: 'https://qncweb-back1.ktvsky.com/20240126/vadd/e99a2c93f500f21c0c90bd13abf6e55a.png',
    vipFirst: 'https://qncweb-back1.ktvsky.com/20240126/vadd/28bd2b26420b332630765e37f8979365.png',
    recommendVip: 'https://qncweb.ktvsky.com/20250611/vadd/f30be27b937e5f9b562b7d63e0d924ba.png',
    recommendNormal: 'https://qncweb.ktvsky.com/20250611/vadd/3691b49e66c19c411e7506b4516d9228.png',
  },
  dark: {
    vip: 'https://qncweb.ktvsky.com/20251201/vadd/f0f40190a192929c89a074ff5c6bc629.png',
    normal: 'https://qncweb.ktvsky.com/20251201/vadd/1fe67fcd06fb0a8c6e70e4f90e0cf04f.png',
    playing: 'https://qncweb-back1.ktvsky.com/20231229/vadd/4d7725826b9d5d9fb310328491232462.png',
    vipTitle: 'https://qncweb-back1.ktvsky.com/20231229/vadd/2e59772e1695c0c987ab66507574612e.png',
    top: 'https://qncweb-back1.ktvsky.com/20231228/vadd/c77c9f60842f004130a0c51ee5ab1ea9.png',
    delete: 'https://qncweb-back1.ktvsky.com/20231228/vadd/081a54e9ebe7257bdd7111cc442ab5a1.png',
    recentSong: 'https://qncweb-back1.ktvsky.com/20240126/vadd/e99a2c93f500f21c0c90bd13abf6e55a.png',
    vipFirst: 'https://qncweb-back1.ktvsky.com/20240126/vadd/28bd2b26420b332630765e37f8979365.png',
    recommendVip: 'https://qncweb.ktvsky.com/20251201/vadd/362269d0c7f1a7db514a8f07c5c9f254.png',
    recommendNormal: 'https://qncweb.ktvsky.com/20251201/vadd/76f5e4935bd9a41a83ab82faa35bf28e.png',
  },
  blue: {
    vip: 'https://qncweb-back1.ktvsky.com/20231213/other/b169c62f20b31a066f4cad1b522296d1.png',
    normal: 'https://qncweb-back1.ktvsky.com/20231213/other/f4dbbb5eb0d63b4b5d5cd87ad8c2a225.png',
    playing: 'https://qncweb-back1.ktvsky.com/20231229/vadd/4d7725826b9d5d9fb310328491232462.png',
    vipTitle: 'https://qncweb-back1.ktvsky.com/20231229/vadd/2e59772e1695c0c987ab66507574612e.png',
    top: 'https://qncweb-back1.ktvsky.com/20231228/vadd/c77c9f60842f004130a0c51ee5ab1ea9.png',
    delete: 'https://qncweb-back1.ktvsky.com/20231228/vadd/081a54e9ebe7257bdd7111cc442ab5a1.png',
    recentSong: 'https://qncweb-back1.ktvsky.com/20240126/vadd/e99a2c93f500f21c0c90bd13abf6e55a.png',
    vipFirst: 'https://qncweb-back1.ktvsky.com/20240126/vadd/28bd2b26420b332630765e37f8979365.png',
    recommendVip: 'https://qncweb.ktvsky.com/20250611/vadd/f30be27b937e5f9b562b7d63e0d924ba.png',
    recommendNormal: 'https://qncweb.ktvsky.com/20250611/vadd/3691b49e66c19c411e7506b4516d9228.png',
  },
}
export const VIP_PACKAGES = [
  {
    'pkg_id': 78,
    'current_fee': 990,
    'desc': '24小时',
    'days': 1,
    'origin_fee': '9.9',
    'day_fee': 0.41
  },
  {
    'pkg_id': 76,
    'desc': '1个月',
    'current_fee': 1990,
    'days': 30,
    'origin_fee': '19.9',
    'day_fee': 0.03
  },
  {
    'pkg_id': 50,
    'desc': '3个月',
    'current_fee': 2190,
    'days': 90,
    'origin_fee': '29.9',
    'month_fee': '9.97',
    'day_fee': 0.01,
    'cur_fee': '21.9',
  }
]
export const USERROLE = {
  'role1': {
    name: '新用户-VIP',
  },
  'role2': {
    name: '新用户-非VIP',
  },
  'role3': {
    name: '老用户-VIP',
  },
  'role4': {
    name: '老用户-非VIP-会员过期',
  },
  'role5': {
    name: '老用户-非VIP-从未付费',
  },
  default: {
    name: '其他',
  },
}
export const GOTOPIMG = {
  default: 'https://qncweb-back1.ktvsky.com/20210819/vadd/ad7c542007253588056f0d4ef24c237d.png',
  light: 'https://qncweb-back1.ktvsky.com/20240229/vadd/2c0bd93740dc0e95aac10acd808bb340.png',
  dark: 'https://qncweb-back1.ktvsky.com/20210819/vadd/ad7c542007253588056f0d4ef24c237d.png'
}

export const CODE_ORDER = {
  '云端歌曲': 21005,
  '雷石90后过期': [21002, 21003]
}

export const WELFARE_DATA = [
  {
    name: '定制台历',
    url: 'https://qncweb-back1.ktvsky.com/20240522/vadd/d520140c4158549063c365cec60151ad.png',
    path: 'sjdg-tl'
  },
  {
    name: '定制玻璃手机壳',
    url: 'https://qncweb-back1.ktvsky.com/20240522/vadd/e9f19178df9a1db6ffa36f3dbc80155d.png',
    path: 'sjdg-blsjk'
  },
  {
    name: 'DIY创意马克杯',
    url: 'https://qncweb-back1.ktvsky.com/20240522/vadd/a0238e5a6f17c5e6b8b9543fccadabb1.png',
    path: 'sjdg-mkb'
  },
  {
    name: '打印5寸照片',
    url: 'https://qncweb-back1.ktvsky.com/20240522/vadd/0427585d14fdd77efb54767ca7d0805c.png',
    path: 'sjdg-5czp'
  },
  {
    name: 'DIY创意红包',
    url: 'https://qncweb-back1.ktvsky.com/20240522/vadd/dc176461833d1b4a3efe58fd4756b6e3.png',
    path: 'sjdg-hb'
  },
  {
    name: '定制车载摇摇乐',
    url: 'https://qncweb-back1.ktvsky.com/20240522/vadd/b90e2b4ff2af801e8cec3879503ca757.png',
    path: 'sjdg-yyl'
  },
]

export const VIP_RIGHTS_ORDER_ICON = {
  'vip_rights': {
    'vip': 'https://qncweb-back1.ktvsky.com/20240621/vadd/d29d4730bb00483c28084b5d3086db21.png',
    'normal': 'https://qncweb-back1.ktvsky.com/20240621/vadd/676c6c5fc4b97fd2c84c7d2af604b5b1.png',
    'top': 'https://qncweb-back1.ktvsky.com/20240624/vadd/8b2098cc90bb333b5213dd2e3c2280df.png',
    'top_btn': 'https://qncweb-back1.ktvsky.com/20240624/vadd/7965b66559eed1bd6cd862cdaa7ec105.png',
  },
  'default': {
    'vip': 'https://qncweb-back1.ktvsky.com/20220929/other/c6446768cc706bcef1ba0af637f555c5.png',
    'normal': 'https://qncweb-back1.ktvsky.com/20220927/other/b98783c0215890643575d27bde5e09e3.png',
    'top': 'https://qncweb-back1.ktvsky.com/20220927/other/199c0b7277e4f4d8a6dfd69e00a6985d.png',
    'top_btn': 'https://qncweb-back1.ktvsky.com/20220927/other/9687499ab4a9a369401e8a6326c9576b.png',
  }
}

export const STATIC_CONFIG = [{
  title: 'VIP专属MV',
  subTitle: '定制专属演唱MV，会员不限次，炫翻全场！',
  route: '/thunder/mv',
  img: 'https://qncweb-back1.ktvsky.com/20220927/other/eec0c82236b82f85f65b269ff026be1d.png',
},
{
  title: 'VIP专属身份标志',
  subTitle: '大屏专属会员专属标识，展示您的尊贵身份！',
  img: 'https://qncweb-back1.ktvsky.com/20220926/other/36db5434483cf6c03fcf166bd14b5e47.png',
}]

export const ROLE4_UNIFIED_CONFIG = {
  dayCard: {
    pkg_id: 78,
    current_fee: 990,
    desc: '24小时',
    days: 1,
    origin_fee: '9.9',
    day_fee: 0.41,
    discount_day_fee: '0.41'
  },
  dayCardGift: {
    pkg_id: 77,
    current_fee: 1980,
    desc: '1天+赠送好友',
    days: 1,
    origin_fee: '19.9'
  },
  monthCard7Days: {
    pkg_id: 52,
    current_fee: 1990,
    desc: '1个月',
    days: 30,
    origin_fee: '19.9',
    day_fee: '0.02',
    discount: true,
    discount_Id: 70,
    discount_tag: '续费立省',
    discount_price: '16.9',
    discount_day_fee: '0.02'
  },
  monthCard90Days: {
    pkg_id: 52,
    current_fee: 1990,
    desc: '1个月',
    days: 30,
    origin_fee: '19.9',
    day_fee: '0.02',
    discount: true,
    discount_Id: 31,
    discount_tag: '立减6元',
    discount_price: '13.9',
    discount_day_fee: '0.02'
  }
}

export const getRole4PackageConfig = (context, basePackages, targetIndex = 1) => {
  const { utils } = require('@/libs/interfaces')
  const packages = [...basePackages]

  const isVipExpiredWithin7Days = utils.util.checkVipExpiredWithinDays({
    $this: context,
    days: -7
  })
  const isVipExpiredOver90Days = !utils.util.checkVipExpiredWithinDays({
    $this: context,
    days: -90
  })

  const dayCardIndex = packages.findIndex((pkg) => pkg.days === 1)

  if (dayCardIndex !== -1) {
    packages[dayCardIndex] = {
      ...packages[dayCardIndex],
      ...ROLE4_UNIFIED_CONFIG.dayCard,
      discount: false
    }
  }

  if (isVipExpiredWithin7Days) {
    packages[targetIndex] = {
      ...packages[targetIndex],
      ...ROLE4_UNIFIED_CONFIG.monthCard7Days
    }
  } else if (isVipExpiredOver90Days) {
    packages[targetIndex] = {
      ...packages[targetIndex],
      ...ROLE4_UNIFIED_CONFIG.monthCard90Days
    }
  }

  return packages
}

export const newRole4DayCardConfig = {
  memberIdArr: [78, 52, 50],
  price: [990, 1490, 2190],
  packagesContent: {
    month: ['24小时', '1个月', '3个月'],
    current: ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥9.9', '¥14.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['', '续费立省', ''],
  },
  originPkgs: [
    {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.9',
      'day_fee': 0.41
    }, {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1天+赠送好友',
      'days': 1,
    }, {
      'pkg_id': 51,
      'desc': '29.8元/1个月',
      'origin_fee': 3980,
      'current_fee': 2980,
      'days': 30,
    }, {
      'pkg_id': 49,
      'current_fee': 4380,
      'desc': '3个月+赠送好友',
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 75,
        'current_fee': 3980,
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
      }
  ],
}

export const HS_STB_TP_CLUB = 'hs';
const HS_CLUB_KAIPING_CC_QUARTER_PKG_ID = 65;
const HS_CLUB_KAIPING_CC_QUARTER_FEE = 2390;
const HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_PKG_ID = 63;
const HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_FEE = 2390;

function cloneCfgJson(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function swapRole4HsClubKaipingCcPackages(base) {
  const c = cloneCfgJson(base);
  const [dayId, monthId] = c.memberIdArr;
  const [p0, pMonth] = c.price;
  c.memberIdArr = [dayId, HS_CLUB_KAIPING_CC_QUARTER_PKG_ID, monthId];
  c.price = [p0, HS_CLUB_KAIPING_CC_QUARTER_FEE, pMonth];

  const pc = c.packagesContent;
  const swap12 = (arr) => {
    if (!arr || arr.length < 3) return arr;
    const next = [...arr];
    [next[1], next[2]] = [next[2], next[1]];
    return next;
  };
  pc.month = swap12(pc.month);
  pc.current = swap12(pc.current);
  pc.origin = swap12(pc.origin);
  pc.showTag = true;
  pc.tagContent = ['', '续费立省', ''];
  pc.bottomTip = '续费立省';
  pc.topTapText = '';
  pc.origin[1] = '¥23.9<i>¥29.9</i>';
  pc.discountTapIndex = 1;
  pc.countdownIndex = 1;

  const ops = c.originPkgs;
  if (ops && ops.length >= 3) {
    const [opDay, opMonth, opQuarter] = ops;
    c.originPkgs = [
      opDay,
      {
        ...opQuarter,
        pkg_id: HS_CLUB_KAIPING_CC_QUARTER_PKG_ID,
        current_fee: HS_CLUB_KAIPING_CC_QUARTER_FEE,
        desc: '3个月',
        days: 90,
        origin_fee: '23.9',
        month_fee: opQuarter.month_fee,
        day_fee: opQuarter.day_fee != null ? opQuarter.day_fee : 0.01,
      },
      opMonth,
    ];
  }

  if (c.giveFriendPackages && c.giveFriendPackages.length >= 3) {
    const g = [...c.giveFriendPackages];
    [g[1], g[2]] = [g[2], g[1]];
    g[1] = {
      ...g[1],
      pkg_id: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_PKG_ID,
      current_fee: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_FEE,
    };
    c.giveFriendPackages = g;
  }
  if (c.originPkgsGiveVip && c.originPkgsGiveVip.length >= 3) {
    const gv = [...c.originPkgsGiveVip];
    [gv[1], gv[2]] = [gv[2], gv[1]];
    gv[1] = {
      ...gv[1],
      pkg_id: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_PKG_ID,
      current_fee: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_FEE,
    };
    c.originPkgsGiveVip = gv;
  }

  c.selectIndex = 1;
  c.discountIndex = 2;

  const pkgs = cloneCfgJson(VIP_PACKAGES);
  const quarterRow = {
    ...pkgs[2],
    pkg_id: HS_CLUB_KAIPING_CC_QUARTER_PKG_ID,
    current_fee: HS_CLUB_KAIPING_CC_QUARTER_FEE,
    desc: '3个月',
    days: 90,
    origin_fee: '23.9',
    cur_fee: '23.9',
  };
  c.packages = [pkgs[0], quarterRow, pkgs[1]];

  return c;
}

function swapRole4HsClubKaipingCcPackagesNoPromo() {
  const pkgs = cloneCfgJson(VIP_PACKAGES);
  const [dayPkg, monthPkg, quarterPkg] = pkgs;
  const quarterRow = {
    ...quarterPkg,
    pkg_id: HS_CLUB_KAIPING_CC_QUARTER_PKG_ID,
    current_fee: HS_CLUB_KAIPING_CC_QUARTER_FEE,
    desc: '3个月',
    days: 90,
    origin_fee: '23.9',
    cur_fee: '23.9',
  };
  const packages = [dayPkg, quarterRow, monthPkg];

  const pc = {
    month: ['24小时', '3个月', '1个月'],
    current: [
      '¥<span>0.41</span>/小时',
      '¥<span>0.01</span>/小时',
      '¥<span>0.03</span>/小时',
    ],
    showFirstOrigin: true,
    origin: ['¥9.9', '¥23.9<i>¥29.9</i>', '¥19.9'],
    showTag: false,
    tagContent: ['', '', ''],
  };

  const patch = {
    memberIdArr: [78, HS_CLUB_KAIPING_CC_QUARTER_PKG_ID, 76],
    price: [990, HS_CLUB_KAIPING_CC_QUARTER_FEE, 1990],
    packagesContent: pc,
    selectIndex: 1,
    discountIndex: null,
    discountDayFee: '',
    packages,
    originPkgs: [
      { ...dayPkg },
      {
        ...quarterRow,
        pkg_id: HS_CLUB_KAIPING_CC_QUARTER_PKG_ID,
        current_fee: HS_CLUB_KAIPING_CC_QUARTER_FEE,
        day_fee: quarterPkg.day_fee != null ? quarterPkg.day_fee : 0.01,
      },
      { ...monthPkg },
    ],
    isDiscount: true,
    isMonthDiscount: false,
  };

  const gf = cloneCfgJson(newRole4DayCardConfig.giveFriendPackages);
  if (gf.length >= 3) {
    [gf[1], gf[2]] = [gf[2], gf[1]];
    gf[1] = {
      ...gf[1],
      pkg_id: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_PKG_ID,
      current_fee: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_FEE,
    };
    gf[2] = {
      ...gf[2],
      pkg_id: 75,
      current_fee: 3980,
      desc: '1个月+赠送好友',
      days: 30,
    };
    patch.giveFriendPackages = gf;
  }
  const gv = cloneCfgJson(newRole4DayCardConfig.originPkgsGiveVip);
  if (gv.length >= 3) {
    [gv[1], gv[2]] = [gv[2], gv[1]];
    gv[1] = {
      ...gv[1],
      pkg_id: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_PKG_ID,
      current_fee: HS_CLUB_KAIPING_CC_QUARTER_GIVE_FRIEND_FEE,
    };
    patch.originPkgsGiveVip = gv;
  }

  return patch;
}

export function buildRole4HsStbOldvipKaipingCcPatch(isRole4VipDay, isRole4VipDay90, withFirstMonthDiscount = true) {
  if (withFirstMonthDiscount === false) {
    return swapRole4HsClubKaipingCcPackagesNoPromo();
  }
  let base = newRole4DayCardConfig;
  if (isRole4VipDay) {
    base = newRole4MonthSkuDiscount7;
  } else if (isRole4VipDay90) {
    base = newRole4MonthSkuDiscount90;
  }
  const patch = swapRole4HsClubKaipingCcPackages(base);
  patch.isDiscount = true;
  patch.isMonthDiscount = true;
  patch.discountDayFee = '0.02';
  return patch;
}

export const newRole4DayCardFirstToast = {
  selectIndex: 0,
  isSpecialPackages: 1,
  isDiscount: true,
  isMonthDiscount: true,
  discountIndex: 0,
  discountDayFee: '0.02',
  memberIdArr: [52, 78, 50],
  price: [1490, 990, 2190],
  packagesContent: {
    month: ['1个月', '24小时', '3个月'],
    current: ['¥<span>0.02</span>/小时', '¥<span>0.41</span>/小时', '¥<span>0.01</span>/小时'],
    showFirstOrigin: true,
    origin: ['¥14.9<i>¥19.9</i>', '¥9.9', '¥21.9<i>¥29.9</i>'],
    showTag: true,
    tagContent: ['续费立省', '', ''],
  },
  originPkgs: [
    {
      'pkg_id': 76,
      'desc': '1个月',
      'current_fee': 1990,
      'days': 30,
      'origin_fee': '19.9',
      'day_fee': 0.03
    }, {
      'pkg_id': 78,
      'current_fee': 990,
      'desc': '24小时',
      'days': 1,
      'origin_fee': '9.9',
      'day_fee': 0.41
    }, {
      'pkg_id': 50,
      'desc': '3个月',
      'current_fee': 2190,
      'days': 90,
      'origin_fee': '21.9',
      'month_fee': '9.97',
      'day_fee': 0.01,
    }],
    giveFriendPackages: [{
      'pkg_id': 51,
      'desc': '29.8元/1个月',
      'origin_fee': 3980,
      'current_fee': 2980,
      'days': 30,
    },
    {
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1日体验+赠送好友',
      'days': 1,
    },
    {
      'pkg_id': 49,
      'current_fee': 4380,
      'desc': '3个月+赠送好友',
      'days': 365,
    }],
    originPkgsGiveVip: [
      {
        'pkg_id': 75,
        'current_fee': 3980,
        'desc': '1个月+赠送好友',
        'days': 30,
      },
      {
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1天+赠送好友',
        'days': 1,
      },
      {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
      },
    ],
}
